<template>
  <div class="bg-white shadow-md relative rounded-lg p-8">
    <el-dialog title="" :visible.sync="centerDialogVisibleg" width="30%" center>
      <template slot="title">
        <h2 class="text-lg text-left text-white font-semibold">
          {{ AddEdit }} Category
        </h2>
      </template>
      <el-form role="form" :model="ruleForm" :rules="rules" ref="ruleForm">
        <div>
          <div class="mb-3">
            <small class="fsize12 bg-white text-dark font-medium"
              >Category Name</small
            >
            <el-form-item prop="name" class="mt-2">
              <el-input
                placeholder="Enter Category Name"
                v-model="ruleForm.name"
                maxlength="50"
              ></el-input>
            </el-form-item>
          </div>
          <div class="mb-3">
            <small class="fsize12 bg-white text-dark font-medium">Image</small>
            <!-- <el-upload
              class="upload-demo"
              drag
              action="#"
              :on-preview="handlePreview"
              :on-remove="handleRemove"
              :file-list="fileList"
              accept="image/*"
            >
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">
                Drop file here or <em>click to upload</em>
              </div>
              <div class="el-upload__tip" slot="tip">
                jpg/png files with a size less than 500kb
              </div>
            </el-upload> -->
            <FileUpload
              v-if="image == null"
              :image="image"
              :onSuccess="handleSuccess"
              class="m-auto"
            />

            <div v-else class="relative">
              <img
                :src="
                  image.slice(0, 4) === 'data' ? image : `${$imageURL}${image}`
                "
                ref="cover"
                class="object-cover imgpre"
              />

              <div
                class="absolute top-0 right-0 bg-white rounded-full p-1 w-8 flex justify-center items-center"
                v-if="image"
              >
                <feather-icon
                  icon="XIcon"
                  svgClasses="w-3 h-3"
                  class="cursor-pointer"
                  @click="handleRemove"
                />
              </div>
            </div>
          </div>
          <div class="grid grid-cols-2 gap-4 mt-6 px-8">
            <vs-button
              type="primary"
              class="bg-primary rounded-lg font-semibold cust-wh fsize14"
              @click.prevent="handleSubmit('ruleForm')"
              >Save</vs-button
            >
            <!-- <vs-button
              type="secondary"
              class="bg-secondary rounded-full font-semibold py-5 fsize14"
              @click="handleClose"
              >Cancel</vs-button
            >
          </div>
        </div>
      </el-form>
    </el-dialog>
    <el-dialog
      title=""
      :visible.sync="isEditSubCategoryPopup"
      width="30%"
      center
    >
      <template slot="title">
        <h2 class="text-lg text-left text-white font-semibold">
          {{ AddEdit }} Sub-Category
        </h2>
      </template>
      <el-form role="form" :model="ruleForm" :rules="rules" ref="ruleForm">
        <div>
          <div class="mb-3">
            <small class="fsize12 bg-white text-dark font-medium"
              >Select Sub-Category</small
            >
            <el-select
              multiple
              v-model="selectedSubcategory"
              value-key="_id"
              placeholder="Select"
              class="w-full mt-2"
            >
              <el-option
                v-for="item in this.tableData"
                :key="item.name"
                :label="item.name"
                :value="item"
              >
              </el-option>
            </el-select>
          </div>
          <div class="grid grid-cols-2 gap-4 mt-6">
            <vs-button
              type="primary"
              class="bg-primary rounded-full font-semibold py-5 fsize14"
              @click.prevent="handleSubmitSubCategory()"
              >Save</vs-button
            > -->

            <vs-button
              type="secondary"
              class="bg-secondary rounded-lg font-semibold cust-wh fsize14"
              @click="handleClose"
              >Cancel</vs-button
            >
          </div>
        </div>
      </el-form>
    </el-dialog>
    <div class="flex w-full justify-between items-center">
      <div class="w-full">
        <div class="relative">
          <el-input
            placeholder="Please input"
            v-model="search"
            maxlength="50"
            class="rounded-none w-full"
          ></el-input>
          <div class="absolute top-0 right-0 mt-2 mr-2">
            <feather-icon icon="SearchIcon" class="" />
          </div>
        </div>
      </div>
      <div class="w-1/4 flex justify-end">
        <vs-button
          color="primary"
          @click="openDialog('Add')"
          class="bg-primary px-8 rounded-lg"
          >Add Category</vs-button
        >
      </div>
    </div>
    <div class="w-full">
      <el-table
        :data="tableData"
        border
        style="width: 100%"
        class="table-responsive table-flush mt-6 cust-overflow-x-primary-color"
        header-row-class-name="thead-light table-th-color"
      >
        <el-table-column
          :index="indexmethod"
          type="index"
          label="Sr.no"
          width="80"
        ></el-table-column>
        <el-table-column prop="image" label="Category Image" min-width="50px">
          <template v-slot="{ row }">
            <img :src="getImage(row.image)" class="w-16 h-16" alt="banh" />
          </template>
        </el-table-column>
        <el-table-column prop="name" label="Category Name" min-width="50px">
          <template v-slot="{ row }">
            <P class="text-gray">{{ row.name }}</P>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="city" label="Sub-Category" min-width="50px">
          <template v-slot="{ row }">
            <div v-for="(i, index) in row.subcategoryId" :key="index">
              <P class="text-gray">{{ i._id }}</P>
            </div>
            <P
              class="text-gray cursor-pointer underline"
              @click="handleAddSubcategory(row)"
              >+ Add Sub-Category</P
            >
          </template>
        </el-table-column> -->
        <!-- <el-table-column prop="city" label="Add Sub-Category" min-width="50px">
          <template v-slot="{ row }">
            <P
              class="text-gray cursor-pointer underline"
              @click="handleAddSubcategory(row)"
              >+ Add Sub-Category</P
            >
          </template>
        </el-table-column> -->

        <el-table-column prop="city" label="Actions" min-width="40px">
          <template v-slot="{ row }">
            <div class="flex gap-1 items-center">
              <feather-icon
                icon="EditIcon"
                svgClasses="w-4 h-4"
                class="cursor-pointer"
                @click="openDialog('Edit', row)"
              />
              <feather-icon
                icon="TrashIcon"
                svgClasses="w-4 h-4"
                @click="deletePopup(row._id)"
                class="cursor-pointer text-danger"
              />
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="w-full flex justify-end mt-6" v-if="totalRows">
      <el-pagination
        background
        layout="prev,pager,next"
        :total="totalRows"
        :page-size="perPage"
        @current-change="setPage"
      ></el-pagination>
    </div>
  </div>
</template>
<script>
import FileUpload from "@/components/FileUpload.vue";
import { mapState } from "vuex";
const debounce = (fn, ms = 0) => {
  let timeoutId;
  return function (...args) {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => fn.apply(this, args), ms);
  };
};
export default {
  data() {
    return {
      drawer: false,
      drawer2: false,
      activeName: "first",
      centerDialogVisibleg: false,
      centerDialogVisiblef: false,
      isEditSubCategoryPopup: false,
      isEditing: false,
      selecteCategory: {},
      selectedSubcategory: [],
      ids_data: [],
      tableData: [
        // {
        //   date: "20 December 2019",
        //   name: "Tom",
        //   state: "PR-1",
        //   city: "Active",
        //   address: "No. 189, Grove St, Los Angeles",
        //   zip: "CA 90036",
        // },
        // {
        //   date: "20 December 2019",
        //   name: "Tom",
        //   state: "PR-1",
        //   city: "Active",
        //   address: "No. 189, Grove St, Los Angeles",
        //   zip: "CA 90036",
        // },
        // {
        //   date: "20 December 2019",
        //   name: "Tom",
        //   state: "PR-1",
        //   city: "Active",
        //   address: "No. 189, Grove St, Los Angeles",
        //   zip: "CA 90036",
        // },
        // {
        //   date: "20 December 2019",
        //   name: "Tom",
        //   state: "PR-1",
        //   city: "Active",
        //   address: "No. 189, Grove St, Los Angeles",
        //   zip: "CA 90036",
        // },
        // {
        //   date: "20 December 2019",
        //   name: "Tom",
        //   state: "PR-1",
        //   city: "Active",
        //   address: "No. 189, Grove St, Los Angeles",
        //   zip: "CA 90036",
        // },
        // {
        //   date: "20 December 2019",
        //   name: "Tom",
        //   state: "PR-1",
        //   city: "Active",
        //   address: "No. 189, Grove St, Los Angeles",
        //   zip: "CA 90036",
        // },
        // {
        //   date: "20 December 2019",
        //   name: "Tom",
        //   state: "PR-1",
        //   city: "Active",
        //   address: "No. 189, Grove St, Los Angeles",
        //   zip: "CA 90036",
        // },
      ],

      search: "",
      totalRows: 0,
      perPage: 10,
      currentPage: 1,
      categoryId: "",
      AddEdit: "Add",

      ruleForm: {
        name: "",
      },
      rules: {
        name: [
          {
            required: true,
            message: "Please Enter Category Name",
            trigger: "blur",
          },
        ],
      },

      image: null,
      coverImage: null,
    };
  },
  components: {
    FileUpload,
  },
  computed: {
    ...mapState("admin", ["login"]),
    ...mapState("user", {
      selectedProject: "selectedProject",
    }),
    ...mapState("portfolioCategory", {
      category: "category",
    }),
  },
  watch: {
    async currentPage() {
      await this.getCategory();
    },
    search: {
      handler: debounce(async function (val) {
        this.currentPage = 1;
        this.getCategory();
      }, 500),
    },
  },
  methods: {
    indexmethod(index) {
      if (this.currentPage > 1) {
        let value = (this.currentPage - 1) * 10;
        return index + value + 1;
      } else {
        return index + 1;
      }
    },
    openDialog(action, data = {}) {
      this.AddEdit = action;
      this.centerDialogVisibleg = true;

      if (action === "Edit") {
        this.ruleForm.name = data.name ? data.name : "";
        this.image = data.image ? data.image : "";
        this.categoryId = data._id ? data._id : "";
      } else {
        this.resetForm();
      }
    },
    handleSubmit(formName) {
      this.ruleForm.name = this.ruleForm.name.trim();
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.onSubmit();
        } else {
          // this.formfield();
          return false;
        }
      });
    },
    getImage(img) {
      return `${this.$imageURL}/${img}`;
    },
    resetForm() {
      this.$refs["ruleForm"].resetFields();
      this.ruleForm.name = "";
      this.image = null;
      this.coverImage = null;
      this.categoryId = "";
    },
    handleSuccess(image) {
      this.coverImage = image;
      this.readerData(image);
    },
    readerData(rawFile) {
      const reader = new FileReader();
      reader.onload = (e) => {
        this.$emit("load", (this.image = e.target.result));
      };
      reader.readAsDataURL(rawFile);
    },
    handleRemove() {
      this.image = null;
      this.coverImage = null;
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
    handleClick(name) {
      this.$router.push({ name: name });
    },
    handleAddAlbum(category) {
      this.$store.commit("portfolioCategory/SELECTED_CATEGORY", category);
      this.handleClick("album");
    },
    handleAddSubcategory(subcategory) {
      this.selecteCategory = subcategory;
      this.isEditSubCategoryPopup = true;
    },
    async handleSubmitSubCategory() {
      let payload2 = {
        adminId: this.selecteCategory.adminId,
        categoryId: this.selecteCategory._id,
        subcategoryRecord: this.selectedSubcategory,
      };
      const createSubCategory = await this.$store.dispatch(
        "portfolioSubcategory/create",
        payload2
      );
      for (let i = 0; i <= this.selectedSubcategory.length; i++) {
        this.ids_data = i._id;
      }
      let payload3 = {
        categoryId: this.selecteCategory._id,
        subcategoryId: this.ids_data,
      };
      const updateCategory = await this.$store.dispatch(
        "portfolioCategory/update",
        payload3
      );
      this.isEditSubCategoryPopup = false;
      this.selectedSubcategory = [];
      await this.getCategory();
    },
    async deletePopup(categoryId) {
      this.$swal({
        title: "Are you sure?",
        icon: "info",
        type: "Warning",
        showCancelButton: true,
        confirmButtonText: "Yes, Delete it",
        cancelButtonText: "No, keep it",
        confirmButtonColor: "#cd3197",
        showCloseButton: true,
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value) {
          this.$swal("Deleted", "Successfully deleted", "success");
          this.handleDelete(categoryId);
        }
      });
    },
    async handleDelete(categoryId) {
      let payload = {
        categoryId: categoryId,
        adminId: this.login._id,
      };
      let data = await this.$store.dispatch(
        "portfolioCategory/delete",
        payload
      );
      this.currentPage = 1;
      this.getCategory();
    },
    async onSubmit() {
      const payload = new FormData();
      payload.append("name", this.ruleForm.name);
      if (this.coverImage) {
        payload.append("image", this.coverImage);
      }
      payload.append("isAdmin", true);
      payload.append("adminId", this.login._id);

      if (!this.coverImage && !this.image) {
        this.$swal.fire({
          text: "Please Upload Image!",
          confirmButtonText: "Okay",
          confirmButtonColor: "#cd3197",
          showCancelButton: false,
        });
        return;
      }

      let loader;
      try {
        loader = this.$loading({
          lock: true,
          text: "Loading",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });

        if (this.AddEdit === "Edit") {
          payload.append("categoryId", this.categoryId);

          const updateCategory = await this.$store.dispatch(
            "portfolioCategory/update",
            payload
          );

          if (updateCategory.code === 200) {
            // console.log(createCategory);
            loader.close();
            this.handleClose();
            await this.$swal({
              title: "Category Updated Successfully!",
              type: "success",
              showCancelButton: false,
              confirmButtonColor: "#830c81",
            });
          }
        } else {
          const createCategory = await this.$store.dispatch(
            "portfolioCategory/create",
            payload
          );

          if (createCategory.code === 200) {
            // console.log(createCategory);
            loader.close();
            this.handleClose();
            await this.$swal({
              title: "Category Created Successfully!",
              type: "success",
              icon: "success",
              showCancelButton: false,
              confirmButtonColor: "#830c81",
            });
          }
        }
        this.ruleForm.name = "";
        this.image = null;
        this.coverImage = null;
        this.getCategory();
        loader.close();
      } catch (error) {
        loader.close();
        console.log(error);
      }
    },
    async getCategory() {
      let curPage = this.currentPage - 1;
      let payload = {
        limit: this.perPage,
        offset: curPage,
      };
      let loader;

      if (this.search !== "")
        Object.assign(payload, { search: this.search.trim() });

      try {
        loader = this.$loading({
          lock: true,
          text: "Loading",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        const getCategory = await this.$store.dispatch(
          "portfolioCategory/get",
          payload
        );
        // console.log(getCategory);
        loader.close();
        if (getCategory.code === 200) {
          this.totalRows = this.category.totalCount;
          this.tableData = this.category.result;
        }
      } catch (error) {
        console.log(error);
        loader.close();
      }
    },
    setPage(page) {
      this.currentPage = page;
    },
    handleClose() {
      this.centerDialogVisibleg = false;
    },
  },
  async mounted() {
    await this.getCategory();
  },
};
</script>
<style>
.imgpre {
  height: 270px;
  border-radius: 8px;
  width: 100%;
}
</style>
